import { ElaborarInformePesquisaComponent } from '../components/retencion-de-fondos/elaborar-informe-pesquisa/elaborar-informe-pesquisa.component';
import { RegistrarRelacionMontosSalvadosComponent } from '../components/retencion-de-fondos/registrar-relacion-montos-salvados/registrar-relacion-montos-salvados.component';

export const COMPONENTS = [
  {
    name: 'Registrar relación de montos salvados',
    value: 'RegistrarRelacionMontosSalvados',
    component: RegistrarRelacionMontosSalvadosComponent,
    caso: 'Retención de fondos',
  },
  // {
  //   name: 'Elaborar informe de pesquisa',
  //   value: 'ElaboraInformePesquisa',
  //   component: ElaborarInformePesquisaComponent,
  //   caso: 'Retención de fondos',
  // },
];
